<script lang="ts">
  import { cn } from '$lib/utils/misc';
  import CornerIcon from '$icons/CornerIcon.svelte';
</script>

<div class="w-full animate-pulse">
  <div
    class={cn('rounded-2xs md:border-gray-dark-6 md:p-3xs w-full border border-transparent p-0')}
  >
    <div class="rounded-2xs md:border-gray-dark-2 md:p-md w-full border border-transparent">
      <div
        class="gap-x-lg rounded-3xs border-gray-dark-1 bg-gray-dark-1 relative flex w-full flex-row gap-y-3 border p-3"
      >
        <CornerIcon class="text-gray-dark-12 absolute right-0 top-0 -m-0.5" />
        <CornerIcon class="text-gray-dark-12 absolute bottom-0 left-0 -m-0.5 rotate-180 " />
        <!-- Project image skeleton -->
        <div class="bg-gray-dark-2 h-[88px] w-[88px] rounded" />

        <div class="flex flex-1 flex-col items-start gap-y-1">
          <!-- Project name skeleton -->
          <div class="bg-gray-dark-4 h-7 w-48 rounded" />

          <!-- Country skeleton -->
          <div class="text-gray-dark-11 mt-1 flex items-center justify-end gap-x-2">
            <div class="bg-gray-dark-4 h-4 w-24 rounded" />
          </div>

          <!-- Tags skeleton -->
          <div class="mt-md flex flex-wrap gap-2.5">
            {#each Array(3) as _}
              <div class="bg-gray-dark-4 h-6 w-20 rounded-full" />
            {/each}
          </div>
        </div>
      </div>

      <!-- Actions skeleton -->
      <div class="mt-3 flex gap-2">
        {#each Array(3) as _}
          <div class="bg-gray-dark-4 h-9 w-24 rounded" />
        {/each}
      </div>
    </div>
  </div>

  <div class="my-9 flex w-full flex-col items-start gap-y-[2.2rem]">
    <!-- Description section -->
    <div class="w-full">
      <!-- Section title skeleton -->
      <div class="bg-gray-dark-4 mb-3 h-6 w-32 rounded" />
      <div class="mt-3 space-y-2">
        {#each Array(4) as _}
          <div class="bg-gray-dark-4 h-4 w-full rounded" />
        {/each}
      </div>
    </div>

    <!-- Team section -->
    <div class="w-full">
      <!-- Section title skeleton -->
      <div class="bg-gray-dark-4 mb-3 h-6 w-32 rounded" />
      <div class="mt-3 flex flex-wrap gap-4">
        {#each Array(3) as _}
          <div class="bg-gray-dark-4 h-12 w-48 rounded" />
        {/each}
      </div>
    </div>

    <!-- Links section -->
    <div class="w-full">
      <!-- Section title skeleton -->
      <div class="bg-gray-dark-4 mb-3 h-6 w-32 rounded" />
      <div class="mt-3 flex gap-4">
        {#each Array(3) as _}
          <div class="bg-gray-dark-4 h-8 w-8 rounded" />
        {/each}
      </div>
    </div>

    <!-- Comments section -->
    <div class="w-full">
      <!-- Section title skeleton -->
      <div class="bg-gray-dark-4 mb-3 h-6 w-32 rounded" />
      <div class="mt-8 space-y-4">
        {#each Array(3) as _}
          <div class="bg-gray-dark-4 h-32 w-full rounded" />
        {/each}
      </div>
    </div>
  </div>
</div>
